import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

const MorningMission = () => {
  const { user } = useAuth();
  const [mood, setMood] = useState("");
  const [intention, setIntention] = useState("");
  const [mission, setMission] = useState("");
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    if (!mood.trim()) {
      toast.error("Tell us how you're arriving today.");
      return;
    }
    setLoading(true);
    setMission("");
    try {
      const { data } = await api.post("/ai/morning-mission", { mood, intention: intention || null });
      setMission(data.mission);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not generate mission");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card-surface p-8" data-testid="morning-mission">
      <div className="text-xs uppercase tracking-[0.2em] text-teal-300/80 mb-2">Morning Mission</div>
      <h3 className="font-display text-2xl text-neutral-100 mb-6">Set the day, gently.</h3>

      <div className="space-y-3">
        <input
          data-testid="mission-mood-input"
          value={mood}
          onChange={(e) => setMood(e.target.value)}
          placeholder="How are you arriving today?"
          className="wwr-input w-full rounded-xl px-4 py-3 text-sm"
        />
        <input
          data-testid="mission-intention-input"
          value={intention}
          onChange={(e) => setIntention(e.target.value)}
          placeholder="Any intention or worry? (optional)"
          className="wwr-input w-full rounded-xl px-4 py-3 text-sm"
        />
        <button
          onClick={generate}
          disabled={loading}
          data-testid="mission-generate-btn"
          className="btn-primary px-5 py-2.5 inline-flex items-center gap-2 disabled:opacity-60"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : <Sparkles size={16} />}
          {loading ? "Writing…" : "Generate mission"}
        </button>
      </div>

      {mission && (
        <div data-testid="mission-output" className="mt-6 rounded-xl border border-teal-500/25 bg-teal-500/5 p-5">
          <div className="text-xs uppercase tracking-widest text-teal-300/80 mb-2">Today's mission</div>
          <p className="text-neutral-100 leading-relaxed whitespace-pre-line">{mission}</p>
          {!user && (
            <p className="text-xs text-neutral-500 mt-4">Sign up to save this to your history.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default MorningMission;
